// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.TooltipUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/* eslint-disable react/no-find-dom-node */
import { findDOMNode } from 'react-dom';

/**
 * Initialize BS tooltip
 * @param  {Object} com       React component that has tooltip
 * @param  {Object} option     Tooltip title
 */
export function initTooltip(com: any, option: any) {
  const node = findDOMNode(com);
  node && option && $izenda(node).tooltip(option);
}

/**
 * Work-around update tooltip content by updating its data-original-title
 * @param  {Object} com   React component that has tooltip
 * @param  {string} title New tooltip title
 */
export function updateTooltip(com: any, title: string) {
  const node = findDOMNode(com);
  if (node) {
    $izenda(node).tooltip('enable');
    $izenda(node).attr('data-original-title', title);
  }
}

/**
 * Disable tooltip
 * @param  {Object} com React component that has tooltip
 */
export function disableTooltip(com: any) {
  const node = findDOMNode(com);
  node && $izenda(node).tooltip('disable');
}

/**
 * Destroy tooltip
 * @param  {Object} com React component that has tooltip
 */
export function destroyTooltip(com: any) {
  const node = findDOMNode(com);
  node && $izenda(node).tooltip('destroy');
}

export default {
  initTooltip: initTooltip,
  updateTooltip: updateTooltip,
  disableTooltip: disableTooltip,
  destroyTooltip: destroyTooltip
};



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.TooltipUtils.js